<template>
  <div class="modal-export">
    <div class="modal-export-bg" @click="close"></div>
    <div class="modal-export-content">
      <div class="modal-export-close" @click="close"></div>

      <ion-row>
        <ion-col size="12" class="ion-text-left">
          <h4>Export</h4>
        </ion-col>
        <ion-col size="12" size-md="6" v-if="$store.state.user_role != 'client'">
          <ion-input placeholder="Report" :value="data.acc" @ionInput="data.acc = $event.target.value;"></ion-input>
        </ion-col>
<!--        <ion-col size="12" size-md="3">-->
<!--          <ion-input placeholder="Date/Place" :value="data.dat" @ionInput="data.dat = $event.target.value;"></ion-input>-->
<!--        </ion-col>-->
<!--        <ion-col size="12" size-md="3">-->
<!--          <ion-input placeholder="Rev" :value="data.rev" @ionInput="data.rev = $event.target.value;"></ion-input>-->
<!--        </ion-col>-->
        <ion-col size="12" size-md="3" v-if="$store.state.user_role != 'client'">
          <ion-input placeholder="Building N°" :value="data.bun" @ionInput="data.bun = $event.target.value;"></ion-input>
        </ion-col>
        <ion-col size="12" size-md="3" v-if="$store.state.user_role != 'client'">
          <ion-input placeholder="Building Type" :value="data.but" @ionInput="data.but = $event.target.value;"></ion-input>
        </ion-col>
<!--        <ion-col size="12" size-md="3">-->
<!--          <ion-input placeholder="Checked by" :value="data.che" @ionInput="data.che = $event.target.value;"></ion-input>-->
<!--        </ion-col>-->
<!--        <ion-col size="12" size-md="3">-->
<!--          <ion-input placeholder="Approved by" :value="data.app" @ionInput="data.app = $event.target.value;"></ion-input>-->
<!--        </ion-col>-->
        <ion-col size="12" class="text-right" v-if="$store.state.user_role != 'client'">
          <ion-button @click="addRev">Add rev.</ion-button>
        </ion-col>
        <ion-col size="12">
          <ion-row v-for="(rev,i) in data.revs" :key="'revs'+i">
            <ion-col size="12" size-md="3">
              <ion-input placeholder="Rev" :value="rev.rev" @ionInput="rev.rev = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-input placeholder="Date" :value="rev.date" @ionInput="rev.date = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-input placeholder="Checked by" :value="rev.checked_by" @ionInput="rev.checked_by = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-input placeholder="Approved by" :value="rev.approved_by" @ionInput="rev.approved_by = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size="10">
              <ion-input placeholder="Brief description" :value="rev.brief_description" @ionInput="rev.brief_description = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size="2" class="text-right">
              <ion-button @click="removeRev(i)">Remove</ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size="6" class="text-left check">
          <ion-checkbox @ionChange="data.images = $event.detail.checked"></ion-checkbox>
          <ion-label>Export Images</ion-label>
        </ion-col>
        <ion-col size="6" class="ion-text-right">
          <ion-button @click="submit">Export</ion-button>
        </ion-col>
      </ion-row>

    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ModalExport",
  props: ['report'],
  data: function () {
    return {
      data: {
        acc: null,
        date: null,
        rev: null,
        bun: null,
        but: null,
        checked_by: null,
        approved_by: null,
        brief_description: null,
        revs: [],
        images: false
      }
    }
  },
  methods: {
    close: function(){
      this.$emit('close')
    },
    submit: function(){
      let dataEncoded = btoa(JSON.stringify(this.data))
      this.$emit('submit', dataEncoded)
    },
    removeRev: function(index) {
      let revs = this.data.revs
      revs.splice(index, 1)
      Vue.set(this.data, 'revs', revs)
    },
    addRev: function(){
      Vue.set(this.data.revs, this.data.revs.length, {
        rev: null,
        date: null,
        brief_description: null,
        checked_by: null,
        approved_by: null
      })
    }
  },
  mounted() {
    this.data.acc = this.report.acc_test_protocol
    this.data.bun = this.report.building_n
    this.data.but = this.report.building_type
    this.data.revs = this.report.revs
  }
}
</script>

<style scoped>
.modal-export {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.modal-export-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.7);
}

.modal-export-content {
  background-color: #fff;
  padding: 20px;
  position: fixed;
  z-index: 100;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  border-radius: 5px;
  width: 700px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.modal-export-close {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 16px;
  height: 16px;
  transform: rotate(45deg);
  cursor: pointer;
}

.modal-export-close::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 7px;
  width: 2px;
  height: 100%;
  background-color: #000;
}

.modal-export-close::after {
  content: '';
  display: block;
  position: absolute;
  top: 7px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

ion-checkbox {
  --size: 25px;
  --border-color: var(--ion-color-primary);
  --background-checked: var(--ion-color-primary);
  --checkmark-color: #fff;
}

.check {
  display: flex;
  align-items: center;
}

.check ion-label {
  margin-left: 15px;
  font-size: 18px;
}
</style>